import custom from "@/style/custom"
import { ElMessage } from "element-plus"
import { defineStore } from "pinia"

/* 工具 */

const rgbToHex = (r:number, g:number, b:number): string => {
    const reg = /^\d{1,3}$/
    if (!reg.test(r + '') || !reg.test(g + '') || !reg.test(b + '')) {
        ElMessage.warning('输入错误的rgb颜色值')
        return ''
    }
    const hexs = [r.toString(16), g.toString(16), b.toString(16)]
    for (let i = 0; i < 3; i++) if (hexs[i].length == 1) hexs[i] = `0${hexs[i]}`
    return `#${hexs.join('')}`
}

const hexToRgb = (str: string): any => {
    let hexs: any = ''
    const reg = /^\#?[0-9A-Fa-f]{6}$/
    if (!reg.test(str)) {
        ElMessage.warning('输入错误的hex')
        return ''
    }
    str = str.replace('#', '')
    hexs = str.match(/../g)
    for (let i = 0; i < 3; i++) hexs[i] = parseInt(hexs[i], 16)
    return hexs
}

const getLightColor = (color: string, level: number): string => {
    const hexReg = /^\#?[0-9A-Fa-f]{6}$/
    const rgbReg = /^rgb\(([0-9]{1,3}\s*,\s*){2}[0-9]{1,3}\s*\)$/
    if (rgbReg.test(color)) {
        const rgb = color.match(/[0-9]{1,3}/g)
        if(rgb && rgb.length === 3) {
            color = rgbToHex(Number(rgb[0]), Number(rgb[1]), Number(rgb[2]))
        }
    }
    if (!hexReg.test(color)) {
        ElMessage.warning('输入错误的hex颜色值' + color)
        return ''
    }
    const rgb = hexToRgb(color)
    for (let i = 0; i < 3; i++) rgb[i] = Math.floor((255 - rgb[i]) * level + rgb[i])
    return rgbToHex(rgb[0], rgb[1], rgb[2])
}
const getDarkColor = (color: string, level: number): string => {
    const hexReg = /^\#?[0-9A-Fa-f]{6}$/
    const rgbReg = /^rgb\(([0-9]{1,3}\s*,\s*){2}[0-9]{1,3}\s*\)$/
    if (rgbReg.test(color)) {
        const rgb = color.match(/[0-9]{1,3}/g)
        if(rgb && rgb.length === 3) {
            color = rgbToHex(Number(rgb[0]), Number(rgb[1]), Number(rgb[2]))
        }
    }
    if (!hexReg.test(color)) {
        ElMessage.warning('输入错误的hex颜色值')
        return ''
    }
    const rgb = hexToRgb(color)
    for (let i = 0; i < 3; i++) rgb[i] = Math.floor(rgb[i] * (1 - level))
    return rgbToHex(rgb[0], rgb[1], rgb[2])
}


/* 功能 */

let userTheme = (JSON.parse(window.localStorage.getItem('userTheme')) || {}) as ReturnType<typeof custom>

const getThemeConfig = () => {
    const assign = (data1, data2) => {
        Object.keys(data1).forEach(key => {
            data1[key] = (Object.prototype.toString.call(data2[key]) === '[object Object]') ?
                assign(data1[key], data2[key]) :( data2[key] || data1[key])
        })
        return data1
    }
    console.log(custom(), userTheme, assign(custom(), userTheme))
    return JSON.parse(JSON.stringify(assign(custom(), userTheme)))
}

// 设置element主题色
const setElementThemeColor = (key: string, value: string, user = true) => {
    document.documentElement.style.setProperty(`--el-color-${key}`, value)
    // 颜色变浅
    for (let i = 1; i <= 9; i++) {
        document.documentElement.style.setProperty(
            `--el-color-${key}-light-${i}`,
            `${getLightColor(value, i / 10)}`
        )
    }
    // 颜色深
    document.documentElement.style.setProperty(
        `--el-color-${key}-dark-2`,
        `${getDarkColor(value, 0.1)}`
    )
    if(user){
        if(!userTheme.element){
            userTheme.element = {} as typeof userTheme.element
        }
        userTheme.element[key] = value
        window.localStorage.setItem('userTheme', JSON.stringify(userTheme))
    }
}
// 设置其他任意颜色
const setThemeConfig = (key: string, value: string, position = [], user = true) => {
    document.documentElement.style.setProperty(
        `--${key}`,
        value
    )
    if (position.length) {
        let obj = userTheme
        position.forEach((key, index) => {
            if(index === position.length - 1) {
                obj[key] = value
                return 
            }
            obj[key] = obj[key] || {}
            obj = obj[key]
        })
    }
    if(user){
        if(!userTheme.element){
            userTheme.element = {} as typeof userTheme.element
        }
        userTheme.element[key] = value
        window.localStorage.setItem('userTheme', JSON.stringify(userTheme))
    }
}

// 恢复默认主题色
const setDefaultTheme = () => {
    userTheme = {} as typeof userTheme
    initTheme()
    window.localStorage.removeItem('userTheme')
}

// 根据custom.ts和用户配置初始化主题
const initTheme = () => {
    const theme = getThemeConfig()
    
    Object.keys(theme.element).forEach(key => {
        console.log('setElementThemeColor', key, theme.element[key])
        setElementThemeColor(key, theme.element[key], false)
    })
    theme.elemet = {}

    const list = getFlatKey(theme)
    Object.keys(list).forEach(key => {
        setThemeConfig(key, getFlatValue(theme, list[key]), [], false)
    })
}
function getFlatValue(obj, key) {
    let result = obj
    key.forEach(key => {
        result = result[key]
    })
    return result
}
function getFlatKey(obj) {
    const back = {}
    recursion(obj, null)
    function recursion(o, prev) {
        for (const key in o) {
            if (o[key] instanceof Object) {
                if (prev === null) {
                    recursion(o[key], [key])
                } else {
                    recursion(o[key], [...prev, key])
                };
            } else {
                if (prev === null) {
                    back[key] = [key]
                } else {
                    back[prev + '-' + key] = [...prev, key]
                };
            };
        };
    };
    return back
};

export default defineStore("theme", () => {
    return { getThemeConfig, setElementThemeColor, setThemeConfig, initTheme, setDefaultTheme, getFlatKey, getFlatValue }
})
